export default __webpack_public_path__ + "static/media/new_essere_il_personaggio.eb8ecb10.jpeg";